import { globalSingleton } from './chunk-N7SZ66QO.js';
import { z } from 'zod';

// src/metadata-analytics/protocol-names.generated.json
var protocol_names_generated_default = {
  brand_entity_types: {
    "0x": "dex",
    "1DEX": "dex",
    "1inch": "defi",
    "1inch Aqua": "dex",
    "1inch Executor": "defi",
    "1inch Fusion": "dex",
    "1inch Fusion (Solana)": "dex",
    "1inch Fusion+": "bridge",
    "1inch SwapVM": "dex",
    "Aave Chain Gateway": "bridge",
    "Aave GHO": "defi",
    "Aave V2": "defi",
    "Aave V3": "defi",
    "Aave V4": "defi",
    "Aave a.DI": "bridge",
    "Across Protocol": "bridge",
    Aerodrome: "dex",
    "Affine Pass NFT transfer": "bridge",
    "Agglayer Vault Bridge": "bridge",
    Aldrin: "dex",
    "Aldrin v2": "dex",
    Algebra: "dex",
    "Allbridge Core": "bridge",
    AlphaQ: "dex",
    Ambient: "dex",
    Angstrom: "dex",
    Aquifer: "dex",
    Arbitrum: "bridge",
    "Arcas transfer": "bridge",
    Archer: "dex",
    "BOB Gateway": "bridge",
    "Backed CCIP bridge": "bridge",
    "Backed CCIP receiver": "bridge",
    "Balancer V2": "dex",
    "Balancer V3": "dex",
    "Bebop Blend": "dex",
    "Beefy bridge transfer": "bridge",
    Beets: "dex",
    BinaryFi: "dex",
    BisonFi: "dex",
    "BisonFi Predict": "dex",
    "Bitcoin Stamps": "nft",
    "Blur Exchange": "nft",
    Bonkswap: "dex",
    "Boop.fun": "dex",
    "Bridge accounting": "bridge",
    "BridgeCCIP receiver": "bridge",
    Byreal: "dex",
    "CCIP Intent Prover": "bridge",
    "CCIP custom staking receiver": "bridge",
    "CCIP xERC20 transfer": "bridge",
    CCIPeth: "bridge",
    "CDK Unified Bridge": "bridge",
    Camelot: "dex",
    Capricorn: "dex",
    "Cashmere CCTP": "bridge",
    Chainflip: "bridge",
    "Chainlink CCIP": "bridge",
    ChangeNOW: "cefi",
    "Circle CCTP": "bridge",
    "Circle Cross-Chain Token Service": "bridge",
    "CoW AMM": "dex",
    "CoW Swap": "dex",
    "Compound III": "defi",
    "Conditional Tokens": "defi",
    ConvertToAssetsPublisher: "bridge",
    Counterparty: "dex",
    Crema: "dex",
    Cropper: "dex",
    CryptoPunks: "nft",
    "Curve ETH/stETH": "dex",
    "Curve pools": "dex",
    "DA Builder": "defi",
    DFlow: "defi",
    "Daimo relayer": "bridge",
    "DeFi Saver": "defi",
    "Debot Router": "defi",
    DefiTuna: "dex",
    Denali: "dex",
    Deriverse: "dex",
    DexLab: "dex",
    "Drift TransferDetail": "bridge",
    ENS: "nft",
    ERC1155: "nft",
    ERC4626: "defi",
    ERC721: "nft",
    Ekubo: "dex",
    Enso: "bridge",
    Enzyme: "dex",
    "Ether CCIP receiver": "bridge",
    "Euler EVC": "defi",
    FLASH: "defi",
    "Farcaster XMR\u2194BTC swap": "dex",
    FixedFloat: "cefi",
    Flint: "dex",
    Fluid: "dex",
    Flux: "dex",
    FluxBeam: "dex",
    "Folks Finance": "bridge",
    "Folks Finance CCIP data adapter": "bridge",
    FreedomXMR: "bridge",
    "GYD L1 CCIP escrow": "bridge",
    Garden: "bridge",
    "Garden HTLC": "dex",
    GatorSwap: "dex",
    Gavel: "dex",
    Geist: "defi",
    "GoonFi v2": "dex",
    "GooseFX Gamma": "dex",
    Guacswap: "dex",
    Hadron: "dex",
    Heaven: "dex",
    "Highway Bridge": "bridge",
    Hop: "bridge",
    HumidiFi: "dex",
    Hyperlane: "bridge",
    "Hyperliquid Bridge2": "bridge",
    "Hyperliquid bridge": "bridge",
    "Hyperliquid trading": "defi",
    "Hyperliquid transfers": "dex",
    "Hyperliquid vaults": "defi",
    "IBC transfer": "bridge",
    "IceCreamSwap Aggregator": "defi",
    Invariant: "dex",
    "JoinMarket CoinJoin": "mixer",
    "Jupiter Order Engine": "dex",
    "Jupiter RFQ": "dex",
    "Jupiter v4": "defi",
    JustLend: "defi",
    JustStable: "defi",
    Kipseli: "dex",
    "Klaster CCIP gateway": "bridge",
    "Kmon minter": "bridge",
    "Krystal V3Utils": "dex",
    "Krystal V4Utils": "dex",
    Kuru: "dex",
    "Kyber Network": "dex",
    "LI.FI": "defi",
    "LI.FI Receiver": "defi",
    LaPoste: "bridge",
    LayerZero: "bridge",
    LemmingsFi: "dex",
    "Lifinity v2": "dex",
    "Linea Bridge": "bridge",
    "Linear withdrawal": "bridge",
    Liquidswap: "dex",
    Lombard: "bridge",
    LunarBase: "dex",
    "M Swap": "dex",
    MToken: "bridge",
    "Maker DSS": "defi",
    Manifest: "dex",
    Maple: "defi",
    "Maverick V2": "dex",
    "Maya Protocol": "bridge",
    Mayan: "bridge",
    Mercurial: "dex",
    MetaDAO: "dex",
    "MetaMask Bridge": "defi",
    "MetaMask Swaps": "defi",
    Meteora: "dex",
    "Meteora DAMM v2": "dex",
    "Meteora DLMM": "dex",
    "Meteora Dynamic Bonding Curve": "dex",
    Metric: "dex",
    "Monero RingCT": "mixer",
    Moonit: "dex",
    "Morpho Blue": "defi",
    "Morpho Bundler3": "defi",
    "Multi lock/mint ERC-721 pool": "bridge",
    Multicall: "defi",
    "NEAR Intents": "bridge",
    "NEX cross-chain index action": "bridge",
    "NFT bridge release": "bridge",
    "NFT floor price message": "bridge",
    "Native bridge transfer": "bridge",
    Neverland: "defi",
    "Noot bridge transfer": "bridge",
    "OFT CCIP token transfer": "bridge",
    "OKX DEX Router": "defi",
    "OKX XBridge": "defi",
    "OP Fork Bridges": "bridge",
    "OP Stack Bridge": "bridge",
    "Obric v2": "dex",
    Obsidian: "dex",
    "Odos V2": "defi",
    OmniBridge: "bridge",
    Omnipair: "dex",
    "OpenBook v2": "dex",
    "Orca Whirlpool": "dex",
    "Orca v1": "dex",
    "Orca v2": "dex",
    Ordinals: "nft",
    "Origin Protocol": "bridge",
    Osmosis: "dex",
    Outland: "bridge",
    "Packed step executor": "defi",
    PancakeSwap: "dex",
    "Pangolin V3": "dex",
    ParaSwap: "dex",
    "Payment Processor (Limit Break)": "nft",
    Pendle: "defi",
    Penguin: "dex",
    Perena: "dex",
    Phoenix: "dex",
    "Phoenix Eternal": "defi",
    "Plasma Vault": "defi",
    PolsV2MigrationEth: "bridge",
    "Polygon PoS Bridge": "bridge",
    "Polymarket CTF Exchange": "defi",
    "Polymarket Neg Risk": "defi",
    "Polymarket UMA Adapter": "defi",
    Pons: "dex",
    "Privacy Pools / 0xbow": "mixer",
    "Pump Router": "defi",
    PumpSwap: "dex",
    Quantum: "dex",
    Quay: "dex",
    RAILGUN: "mixer",
    "Rare Bridge": "bridge",
    "Raydium AMM v4": "dex",
    "Raydium CLMM": "dex",
    "Raydium CPMM": "dex",
    "Raydium LaunchLab": "dex",
    Relay: "bridge",
    Riptide: "dex",
    Rootstock: "bridge",
    "Runespear / SuperEarn": "bridge",
    RunnerRodeo: "dex",
    "SOUCore CCIP receiver": "bridge",
    "SPL Token Swap": "dex",
    Saber: "dex",
    "Saber (Decimals)": "dex",
    "Safe Rollup (Sepolia demonstration)": "bridge",
    Saros: "dex",
    "Saros DLMM": "dex",
    "Scale AMM": "dex",
    "Scale VMM": "dex",
    Scorch: "dex",
    "Scroll Bridge": "bridge",
    Seaport: "nft",
    "SideShift.ai": "cefi",
    "Sky / USDS": "defi",
    Socket: "bridge",
    SolFi: "dex",
    "SolFi v2": "dex",
    "Stabble CLMM": "dex",
    "Stabble Stable Swap": "dex",
    "Stabble Weighted Swap": "dex",
    Stableswap: "dex",
    "Stake DAO Votemarket": "defi",
    "Stargate Finance": "bridge",
    StarkGate: "bridge",
    "Starknet Messaging": "bridge",
    StepN: "dex",
    SunPump: "dex",
    SunSwap: "dex",
    SushiSwap: "dex",
    "SwapX router": "dex",
    Symbiosis: "bridge",
    SyncSwap: "dex",
    "Synthereum CCIP bridge": "bridge",
    THORChain: "bridge",
    "THORChain-style memo": "bridge",
    "TRUF transfer": "bridge",
    "Taiko Bridge": "bridge",
    TaurusFi: "dex",
    TeleSwap: "bridge",
    "Teleport / Abridge": "bridge",
    Tenbin: "bridge",
    TesseraV: "dex",
    "Tibbir Bridge": "bridge",
    "Tokemak Cross-Chain Messaging": "bridge",
    "Tornado Cash": "mixer",
    "Tornado Cash Nova": "mixer",
    Trench: "dex",
    Trends: "dex",
    Tycho: "defi",
    "USDT0 / Legacy Mesh": "bridge",
    "Unattributed CoinJoin": "mixer",
    Uniswap: "dex",
    "Veda BoringVault": "defi",
    Virtuals: "dex",
    WOOFi: "dex",
    "Wagyu bridge": "bridge",
    "Wasabi CoinJoin": "mixer",
    WhaleStreet: "dex",
    "Whirlpool CoinJoin": "mixer",
    "Winnables Ccip Receiver": "bridge",
    "Wintermute Market Maker": "company",
    "Wishing Pond": "bridge",
    Wormhole: "bridge",
    X2Y2: "nft",
    "XMR\u2194BTC atomic swap": "dex",
    XSwap: "bridge",
    "ZK Stack Bridge": "bridge",
    "Zcash shielded pools": "mixer",
    ZeroFi: "dex",
    dYdX: "defi",
    "dYdX order book": "defi",
    "dYdX subaccounts": "defi",
    "deBridge DLN": "bridge",
    iZiSwap: "dex",
    "pump.fun": "dex",
    zkBob: "mixer"
  },
  categories: {
    aave_ccip: "bridge",
    aave_gateway: "bridge",
    aave_gho: "lending",
    aave_governance: "governance",
    aave_safety_module: "staking",
    aave_umbrella: "staking",
    aave_v2: "lending",
    aave_v3: "lending",
    aave_v4: "lending",
    account_closure: "infrastructure",
    accounting_ccip_receiver: "bridge",
    across: "bridge",
    address_lookup_table: "infrastructure",
    aerodrome: "exchange",
    aerodrome_slipstream: "exchange",
    affine_pass_ccip_receiver: "bridge",
    agglayer_vault_bridge: "bridge",
    aldrin: "exchange",
    aldrin_v2: "exchange",
    algebra: "exchange",
    algebra_router: "exchange",
    allbridge_core: "bridge",
    allbridge_core_cctp: "bridge",
    alphaq: "exchange",
    ambient: "exchange",
    amnis: "staking",
    angstrom: "exchange",
    ape_church: "gambling",
    aquifer: "exchange",
    arbitrage_bot_foaft: "mev",
    arbitrum_bridge: "bridge",
    arbos: "infrastructure",
    arc_native_coin: "infrastructure",
    arcas_ccip_receiver: "bridge",
    archer: "exchange",
    associated_token_account: "erc20",
    babylon_checkpoint: "infrastructure",
    babylon_staking: "staking",
    backed_ccip_bridge: "bridge",
    backed_ccip_receiver: "bridge",
    balancer_v2: "exchange",
    balancer_v3: "exchange",
    banana_gun: "mev",
    bebop: "exchange",
    beefy_ccip_receiver: "bridge",
    beets: "exchange",
    binaryfi: "exchange",
    bisonfi: "exchange",
    bisonfi_predict: "exchange",
    bitcoin_bridge_memo: "infrastructure",
    bitcoin_org: "infrastructure",
    bitcoin_stamps: "nft",
    blur: "nft",
    bob_gateway: "bridge",
    bonkswap: "exchange",
    boop_fun: "exchange",
    bpf_loader: "infrastructure",
    bpf_loader2: "infrastructure",
    bpf_loader_upgradeable: "infrastructure",
    brc20: "erc20",
    bridge_ccip_receiver: "bridge",
    builder_payments: "mev",
    byreal: "exchange",
    camelot_aggregator: "exchange",
    camelot_farming: "exchange",
    camelot_launchpad: "exchange",
    camelot_nitro: "exchange",
    camelot_staking: "exchange",
    camelot_v2: "exchange",
    camelot_v3: "exchange",
    camelot_v4: "exchange",
    camelot_xgrail: "exchange",
    camelot_yield_booster: "exchange",
    candide: "account_abstraction",
    capricorn: "exchange",
    carrot: "staking",
    cashmere_cctp: "bridge",
    cashmere_cctp_program: "bridge",
    ccip_burnmint_token_pool: "bridge",
    ccip_cctp_token_pool: "bridge",
    ccip_fee_quoter: "bridge",
    ccip_lockrelease_token_pool: "bridge",
    ccip_offramp: "bridge",
    ccip_prover: "bridge",
    ccip_rmn_remote: "bridge",
    ccip_router: "bridge",
    ccipeth_ccip_receiver: "bridge",
    cctp: "bridge",
    cctp_message_transmitter: "bridge",
    cctp_message_transmitter_v2: "bridge",
    cctp_token_messenger_minter: "bridge",
    cctp_token_messenger_minter_v2: "bridge",
    chainflip: "bridge",
    chainlink_automation: "oracle",
    chainlink_ccip: "bridge",
    chainlink_cre: "oracle",
    chainlink_cre_automation_receiver: "oracle",
    chainlink_cre_workflow_router: "oracle",
    chainlink_cron_upkeep: "oracle",
    chainlink_data_feeds: "oracle",
    chainlink_data_feeds_cache: "oracle",
    chainlink_data_streams: "oracle",
    chainlink_direct_request: "oracle",
    chainlink_functions: "oracle",
    chainlink_payment_abstraction: "oracle",
    chainlink_sequencer: "oracle",
    chainlink_staking: "staking",
    chainlink_vrf: "oracle",
    changenow: "instant_swap",
    circle_bridge_kit: "bridge",
    circle_ccts: "bridge",
    circle_fiat_token: "erc20",
    circle_fiattokenfactory: "infrastructure",
    circle_usdc_xrpl: "other",
    compound_v3: "lending",
    compute_budget: "infrastructure",
    conditional_tokens: "derivatives",
    convert_to_assets_publisher: "bridge",
    coredao: "staking",
    cosmos_authz: "account_abstraction",
    cosmos_bank: "infrastructure",
    cosmos_distribution: "staking",
    cosmos_feegrant: "account_abstraction",
    cosmos_gov: "governance",
    cosmos_staking: "staking",
    cosmwasm: "infrastructure",
    counterparty: "exchange",
    cow_amm: "exchange",
    cowswap: "exchange",
    credit_coop_bridge: "bridge",
    crema: "exchange",
    cropper: "exchange",
    cryptopunks: "nft",
    curve: "exchange",
    curve_steth: "exchange",
    custom_staking_ccip_receiver: "bridge",
    da_builder: "aggregator",
    daimo_relayer: "bridge",
    debot_router: "aggregator",
    debridge_dln: "bridge",
    defisaver: "aggregator",
    defituna: "exchange",
    denali: "exchange",
    deriverse: "exchange",
    dexlab: "exchange",
    dflow_aggregator_v4: "aggregator",
    drift_ccip_receiver: "bridge",
    dydx: "derivatives",
    dydx_clob: "derivatives",
    dydx_sending: "derivatives",
    ed25519_program: "infrastructure",
    eigenlayer: "staking",
    eip7702: "account_abstraction",
    ekubo: "exchange",
    ens: "nft",
    enso: "bridge",
    enzyme: "exchange",
    erc1155: "nft",
    erc20: "erc20",
    erc4337: "account_abstraction",
    erc4626: "lending",
    erc721: "nft",
    ethena: "staking",
    ether_ccip_receiver: "bridge",
    ethereum_consensus: "staking",
    etherfi: "staking",
    euler: "lending",
    exsat: "infrastructure",
    farcaster_xmr_btc: "exchange",
    fixedfloat: "instant_swap",
    flash_router: "aggregator",
    flint: "exchange",
    fluid: "exchange",
    fluid_dex: "exchange",
    fluid_dex_observation_upkeep: "oracle",
    flux: "exchange",
    fluxbeam: "exchange",
    folks_finance: "bridge",
    folks_finance_ccip_data: "bridge",
    frax_ether: "staking",
    freedomxmr: "bridge",
    garden: "bridge",
    garden_htlc: "exchange",
    gatorswap: "exchange",
    gavel: "exchange",
    geist: "lending",
    generic: "other",
    gnosis_safe: "safe",
    goonfi_v2: "exchange",
    goosefx_gamma: "exchange",
    guacswap: "exchange",
    gyd_escrow_ccip_receiver: "bridge",
    hadron: "exchange",
    hathor: "infrastructure",
    heaven: "exchange",
    helium_treasury: "staking",
    highway_bridge: "bridge",
    hop: "bridge",
    huma: "staking",
    humidifi: "exchange",
    hylo_exchange: "staking",
    hylo_stability_pool: "staking",
    hyperlane: "bridge",
    hyperliquid_account: "account_abstraction",
    hyperliquid_bridge: "bridge",
    hyperliquid_bridge2: "bridge",
    hyperliquid_evm: "infrastructure",
    hyperliquid_staking: "staking",
    hyperliquid_trading: "derivatives",
    hyperliquid_transfer: "exchange",
    hyperliquid_validator: "infrastructure",
    hyperliquid_vault: "derivatives",
    ibc_core: "infrastructure",
    ibc_transfer: "bridge",
    icecreamswap_aggregator: "aggregator",
    invariant: "exchange",
    iziswap: "exchange",
    iziswap_pool: "exchange",
    jaredfromsubway: "mev",
    joinmarket_coinjoin: "privacy",
    jupiter_dca: "exchange",
    jupiter_lend_earn: "lending",
    jupiter_limit_order: "exchange",
    jupiter_limit_order_v2: "exchange",
    jupiter_order_engine: "exchange",
    jupiter_perps: "derivatives",
    jupiter_rfq_v2: "exchange",
    jupiter_v4: "aggregator",
    jupiter_v6: "aggregator",
    juplend_amm: "exchange",
    juplend_liquidity: "lending",
    justlend: "lending",
    juststable: "lending",
    kipseli: "exchange",
    klaster_ccip_gateway: "bridge",
    kmon_minter_ccip_receiver: "bridge",
    krystal_v3_utils: "exchange",
    krystal_v4_utils: "exchange",
    kuru: "exchange",
    kyber_legacy: "exchange",
    kyberswap_fairflow: "exchange",
    kyberswap_limit_order: "exchange",
    kyberswap_meta_aggregator: "aggregator",
    kyberswap_zap: "exchange",
    laposte: "bridge",
    layerzero_dvn: "bridge",
    layerzero_endpoint: "bridge",
    layerzero_executor: "bridge",
    layerzero_oft: "bridge",
    layerzero_onft: "bridge",
    layerzero_pricefeed: "bridge",
    layerzero_read: "bridge",
    layerzero_uln: "bridge",
    layerzero_v1: "bridge",
    layerzero_v2: "bridge",
    lemmingsfi: "exchange",
    lendvest_lido_upkeep: "oracle",
    lido: "staking",
    lifi: "aggregator",
    lifi_receivers: "aggregator",
    lifi_solana_program_1: "infrastructure",
    lifinity_v2: "exchange",
    lighthouse: "infrastructure",
    limit_order_registry_upkeep: "oracle",
    limitbreak_payment_processor: "nft",
    linea_bridge: "bridge",
    linear_ccip_receiver: "bridge",
    liquidswap: "exchange",
    loader_v4: "infrastructure",
    lombard: "bridge",
    lunarbase: "exchange",
    m_swap: "exchange",
    magic_eden_v2: "nft",
    maker_dss: "lending",
    maker_dss_cron_keeper_upkeep: "oracle",
    manifest: "exchange",
    maple: "lending",
    marinade: "staking",
    maverick_v2: "exchange",
    mayachain: "bridge",
    mayan: "bridge",
    mayan_cpi_proxy: "infrastructure",
    mayan_fast_mctp: "bridge",
    mayan_fee_manager: "bridge",
    mayan_mctp: "bridge",
    mayan_spl_utils: "infrastructure",
    mayan_swift_v1: "bridge",
    mayan_swift_v2: "bridge",
    mercurial: "exchange",
    metadao: "exchange",
    metamask_bridge: "aggregator",
    metamask_delegation: "account_abstraction",
    metamask_swaps: "aggregator",
    metaplex_bubblegum: "nft",
    metaplex_core: "nft",
    metaplex_token_metadata: "nft",
    meteora_damm_v2: "exchange",
    meteora_dbc: "exchange",
    meteora_dlmm: "exchange",
    meteora_dynamic_vault: "staking",
    meteora_pools: "exchange",
    metric: "exchange",
    metric_oracles: "oracle",
    mev_blocker: "mev",
    mev_bot: "mev",
    monero_ringct: "privacy",
    moonit: "exchange",
    morpho_blue: "lending",
    morpho_bundler3: "lending",
    mtoken: "bridge",
    multi_lock_mint_ccip_receiver: "bridge",
    multicall: "aggregator",
    native_ccip_receiver: "bridge",
    native_loader: "infrastructure",
    native_transfer: "erc20",
    near_intents: "bridge",
    neverland: "lending",
    nex_labs_ccip_receiver: "bridge",
    nft_floor_ccip_receiver: "bridge",
    nft_release_ccip_receiver: "bridge",
    noble_forwarding: "infrastructure",
    noot_ccip_receiver: "bridge",
    obric_v2: "exchange",
    obsidian: "exchange",
    odos: "aggregator",
    oft_ccip_receiver: "bridge",
    okx_dex_router: "aggregator",
    okx_xbridge: "aggregator",
    omni_layer: "erc20",
    omnibridge: "bridge",
    omnipair: "exchange",
    one_dex: "exchange",
    oneinch: "aggregator",
    oneinch_aqua: "exchange",
    oneinch_delegation: "governance",
    oneinch_executor: "aggregator",
    oneinch_fusion: "exchange",
    oneinch_fusion_dst: "bridge",
    oneinch_fusion_dst_v2: "bridge",
    oneinch_fusion_plus: "bridge",
    oneinch_fusion_src: "bridge",
    oneinch_fusion_src_v2: "bridge",
    oneinch_fusion_whitelist: "bridge",
    oneinch_fusion_whitelist_v2: "bridge",
    oneinch_solana_fusion: "exchange",
    oneinch_solana_fusion_whitelist: "infrastructure",
    oneinch_swap_vm: "exchange",
    op_fork_bridge: "bridge",
    op_return_data: "other",
    op_stack_batcher: "infrastructure",
    op_stack_bridge: "bridge",
    op_stack_l1_block: "infrastructure",
    openbook_v2: "exchange",
    orca_v1: "exchange",
    orca_v2: "exchange",
    orca_whirlpool: "exchange",
    ordinals: "nft",
    origin_protocol: "bridge",
    osmosis_swap: "exchange",
    outland: "bridge",
    packed_steps: "aggregator",
    pancakeswap_factory: "exchange",
    pancakeswap_router: "exchange",
    pancakeswap_solana: "exchange",
    pancakeswap_v3_pool: "exchange",
    pangolin_v3: "exchange",
    paraswap: "exchange",
    pendle: "derivatives",
    penguin: "exchange",
    perena: "exchange",
    perena_star_v2: "staking",
    phoenix: "exchange",
    phoenix_eternal: "derivatives",
    plasma_vault: "aggregator",
    pols_v2_migration: "bridge",
    polygon_cdk_bridge: "bridge",
    polygon_pos_bridge: "bridge",
    polymarket_ctf_exchange: "derivatives",
    polymarket_neg_risk: "derivatives",
    polymarket_uma_adapter: "derivatives",
    pons_v2_curve: "exchange",
    pons_v2_factory: "exchange",
    privacy_pools: "privacy",
    private_packed_searchers: "mev",
    private_swap_executors: "mev",
    program_metadata: "infrastructure",
    pump_router: "aggregator",
    pumpfun: "exchange",
    pumpfun_fee: "exchange",
    pumpfun_mayhem: "mev",
    pumpswap_amm: "exchange",
    quantum: "exchange",
    quay: "exchange",
    railgun: "privacy",
    rare_bridge_ccip_receiver: "bridge",
    raydium_amm_v4: "exchange",
    raydium_clmm: "exchange",
    raydium_cpmm: "exchange",
    raydium_launchlab: "exchange",
    re_reserve_feeds: "oracle",
    relay: "bridge",
    ripple_rlusd: "other",
    riptide: "exchange",
    rootstock: "bridge",
    runes: "erc20",
    runespear: "bridge",
    runner_rodeo: "exchange",
    saber: "exchange",
    saber_decimals: "exchange",
    safe_rollup: "bridge",
    sanctum_infinity: "staking",
    sanctum_multi_validator: "staking",
    sanctum_prop_s: "staking",
    sanctum_router: "staking",
    sanctum_single_validator: "staking",
    sanctum_sols: "staking",
    sanctum_spl_stake_pool: "staking",
    saros: "exchange",
    saros_dlmm: "exchange",
    save_cre_receiver: "oracle",
    scale_amm: "exchange",
    scale_vmm: "exchange",
    scorch: "exchange",
    scorch_2: "exchange",
    scroll_bridge: "bridge",
    seaport: "nft",
    secp256k1_program: "infrastructure",
    sideshift: "instant_swap",
    sky_usds: "lending",
    socket: "bridge",
    solayer: "staking",
    solfi: "exchange",
    solfi_v2: "exchange",
    soucore_ccip_receiver: "bridge",
    spl_memo_v1: "infrastructure",
    spl_memo_v2: "infrastructure",
    spl_token: "erc20",
    spl_token_2022: "erc20",
    spl_token_swap: "exchange",
    stabble_clmm: "exchange",
    stabble_stable_swap: "exchange",
    stabble_weighted_swap: "exchange",
    stableswap: "exchange",
    stacks: "infrastructure",
    stake: "infrastructure",
    stakedao_votemarket: "governance",
    stargate: "bridge",
    starkgate: "bridge",
    starknet_messaging: "bridge",
    stepn: "exchange",
    strap_guard: "infrastructure",
    sunpump: "exchange",
    sunswap: "exchange",
    sushiswap_router: "exchange",
    sushiswap_v2_factory: "exchange",
    swapx: "exchange",
    symbiosis: "bridge",
    syncswap_v1: "exchange",
    syncswap_v2_1_aqua: "exchange",
    synthereum_ccip_bridge: "bridge",
    syscoin: "infrastructure",
    system: "infrastructure",
    taiko_bridge: "bridge",
    taurusfi: "exchange",
    teleport: "bridge",
    teleswap: "bridge",
    tenbin: "bridge",
    tensor_swap: "nft",
    tessera_v: "exchange",
    tether: "erc20",
    thorchain: "bridge",
    thorchain_deposit: "bridge",
    thorchain_memo: "bridge",
    thorchain_node: "infrastructure",
    tibbir: "bridge",
    tokemak_incentive_prices_upkeep: "oracle",
    tokemak_messaging: "bridge",
    tokemak_stats_upkeep: "oracle",
    tornado_cash: "privacy",
    tornado_cash_nova: "privacy",
    trench: "exchange",
    trends: "exchange",
    truf_ccip_receiver: "bridge",
    tycho: "aggregator",
    uma_optimistic_oracle: "oracle",
    unattributed_coinjoin: "privacy",
    uniswap_calibur: "account_abstraction",
    uniswap_liquidity_launchpad: "exchange",
    uniswap_permissioned_pools: "exchange",
    uniswap_permit2: "exchange",
    uniswap_protocol_fees: "governance",
    uniswap_stable_pair: "exchange",
    uniswap_swap_proxy: "exchange",
    uniswap_the_compact: "infrastructure",
    uniswap_universal_router: "exchange",
    uniswap_v1_exchange: "exchange",
    uniswap_v1_factory: "exchange",
    uniswap_v2_factory: "exchange",
    uniswap_v2_migrator: "exchange",
    uniswap_v2_pair: "exchange",
    uniswap_v2_router: "exchange",
    uniswap_v3_factory: "exchange",
    uniswap_v3_migrator: "exchange",
    uniswap_v3_pool: "exchange",
    uniswap_v3_position_manager: "exchange",
    uniswap_v3_router: "exchange",
    uniswap_v3_staker: "exchange",
    uniswap_v3_utilities: "exchange",
    uniswap_v4: "exchange",
    uniswap_v4_position_manager: "exchange",
    uniswap_v4_utilities: "exchange",
    uniswapx: "exchange",
    uniswapx_utilities: "exchange",
    usdt0: "bridge",
    vault_liquid_unstake: "staking",
    veda_boring_vault: "lending",
    virtuals: "exchange",
    voltr: "staking",
    vote: "infrastructure",
    wagyu: "bridge",
    wasabi_coinjoin: "privacy",
    whalestreet: "exchange",
    whirlpool_coinjoin: "privacy",
    winnables_ccip_receiver: "bridge",
    wintermute: "mev",
    wishing_pond: "bridge",
    woofi: "exchange",
    wormhole: "bridge",
    wormhole_cctp_with_executor: "bridge",
    wormhole_core_bridge: "bridge",
    wormhole_executor: "bridge",
    wormhole_post_message_shim: "bridge",
    wormhole_token_bridge: "bridge",
    wormhole_verify_vaa_shim: "bridge",
    x2y2: "nft",
    xerc20_ccip_receiver: "bridge",
    xmr_btc_swap: "exchange",
    xorca: "staking",
    xswap: "bridge",
    zcash_shielded: "privacy",
    zeroex: "exchange",
    zerofi: "exchange",
    zkbob: "privacy",
    zksync_bridge: "bridge",
    zodiac: "safe"
  },
  category_labels: {
    account_abstraction: "Account abstraction",
    aggregator: "Aggregator",
    bridge: "Bridge",
    derivatives: "Derivatives",
    erc20: "Token",
    exchange: "Exchange",
    exploit: "Exploit",
    flashloan: "Flash loan",
    gambling: "Gambling",
    governance: "Governance",
    infrastructure: "Chain infrastructure",
    instant_swap: "Instant swap",
    lending: "Lending",
    mev: "MEV",
    nft: "NFT",
    oracle: "Oracle",
    other: "Other",
    privacy: "Privacy",
    safe: "Multisig",
    staking: "Staking"
  },
  names: {
    aave_ccip: "Aave a.DI",
    aave_gateway: "Aave Chain Gateway",
    aave_gho: "Aave GHO",
    aave_governance: "Aave Governance",
    aave_safety_module: "Aave Safety Module",
    aave_umbrella: "Aave Umbrella",
    aave_v2: "Aave V2",
    aave_v3: "Aave V3",
    aave_v4: "Aave V4",
    account_closure: "Account closure",
    accounting_ccip_receiver: "Bridge accounting",
    across: "Across Protocol",
    address_lookup_table: "Address Lookup Table",
    aerodrome: "Aerodrome / Velodrome",
    aerodrome_slipstream: "Aerodrome Slipstream",
    affine_pass_ccip_receiver: "Affine Pass NFT transfer",
    agglayer_vault_bridge: "Agglayer Vault Bridge",
    aldrin: "Aldrin",
    aldrin_v2: "Aldrin v2",
    algebra: "Algebra",
    algebra_router: "Algebra",
    allbridge_core: "Allbridge Core",
    allbridge_core_cctp: "Allbridge Core CCTP",
    alphaq: "AlphaQ",
    ambient: "Ambient",
    amnis: "Amnis",
    angstrom: "Angstrom",
    ape_church: "Ape Church",
    aquifer: "Aquifer",
    arbitrage_bot_foaft: "Arbitrage Bot (FoaFt)",
    arbitrum_bridge: "Arbitrum Bridge",
    arbos: "ArbOS",
    arc_native_coin: "Arc native coin",
    arcas_ccip_receiver: "Arcas transfer",
    archer: "Archer",
    associated_token_account: "Associated Token Account",
    babylon_checkpoint: "Babylon checkpoint",
    babylon_staking: "Babylon",
    backed_ccip_bridge: "Backed CCIP bridge",
    backed_ccip_receiver: "Backed CCIP receiver",
    balancer_v2: "Balancer V2",
    balancer_v3: "Balancer V3",
    banana_gun: "Banana Gun",
    bebop: "Bebop Blend",
    beefy_ccip_receiver: "Beefy bridge transfer",
    beets: "Beets",
    binaryfi: "BinaryFi",
    bisonfi: "BisonFi",
    bisonfi_predict: "BisonFi Predict",
    bitcoin_bridge_memo: "Bitcoin bridge memo",
    bitcoin_org: "Bitcoin.org",
    bitcoin_stamps: "Bitcoin Stamps",
    blur: "Blur Exchange",
    bob_gateway: "BOB Gateway",
    bonkswap: "Bonkswap",
    boop_fun: "Boop.fun",
    bpf_loader: "BPF Loader v1",
    bpf_loader2: "BPF Loader v2",
    bpf_loader_upgradeable: "BPF Upgradeable Loader",
    brc20: "BRC-20",
    bridge_ccip_receiver: "BridgeCCIP receiver",
    builder_payments: "Builder balance payments",
    byreal: "Byreal",
    camelot_aggregator: "Camelot Aggregator",
    camelot_farming: "Camelot spNFT Farming",
    camelot_launchpad: "Camelot Launchpad",
    camelot_nitro: "Camelot Nitro Pools",
    camelot_staking: "Camelot Real Yield Staking",
    camelot_v2: "Camelot V2",
    camelot_v3: "Camelot V3",
    camelot_v4: "Camelot V4",
    camelot_xgrail: "Camelot xGRAIL",
    camelot_yield_booster: "Camelot Yield Booster",
    candide: "Candide",
    capricorn: "Capricorn",
    carrot: "Carrot",
    cashmere_cctp: "Cashmere CCTP",
    cashmere_cctp_program: "Cashmere CCTP",
    ccip_burnmint_token_pool: "Chainlink CCIP Burn-Mint Token Pool",
    ccip_cctp_token_pool: "Chainlink CCIP CCTP Token Pool",
    ccip_fee_quoter: "Chainlink CCIP Fee Quoter",
    ccip_lockrelease_token_pool: "Chainlink CCIP Lock-Release Token Pool",
    ccip_offramp: "Chainlink CCIP OffRamp",
    ccip_prover: "CCIP Intent Prover",
    ccip_rmn_remote: "Chainlink CCIP RMN Remote",
    ccip_router: "Chainlink CCIP Router",
    ccipeth_ccip_receiver: "CCIPeth",
    cctp: "Circle CCTP",
    cctp_message_transmitter: "Circle CCTP Message Transmitter",
    cctp_message_transmitter_v2: "Circle CCTP Message Transmitter V2",
    cctp_token_messenger_minter: "Circle CCTP Token Messenger Minter",
    cctp_token_messenger_minter_v2: "Circle CCTP Token Messenger Minter V2",
    chainflip: "Chainflip",
    chainlink_automation: "Chainlink Automation",
    chainlink_ccip: "Chainlink CCIP",
    chainlink_cre: "Chainlink CRE",
    chainlink_cre_automation_receiver: "CRE Automation receiver",
    chainlink_cre_workflow_router: "CRE workflow router",
    chainlink_cron_upkeep: "Chainlink Cron Upkeep",
    chainlink_data_feeds: "Chainlink Data Feeds",
    chainlink_data_feeds_cache: "Chainlink Data Feeds Cache",
    chainlink_data_streams: "Chainlink Data Streams",
    chainlink_direct_request: "Chainlink Direct Request",
    chainlink_functions: "Chainlink Functions",
    chainlink_payment_abstraction: "Chainlink Payment Abstraction",
    chainlink_sequencer: "Chainlink Sequencer Uptime",
    chainlink_staking: "Chainlink Staking v0.2",
    chainlink_vrf: "Chainlink VRF v2.5",
    changenow: "ChangeNOW",
    circle_bridge_kit: "Circle Bridge Kit",
    circle_ccts: "Circle Cross-Chain Token Service",
    circle_fiat_token: "Circle USDC (issuer)",
    circle_fiattokenfactory: "Circle FiatTokenFactory",
    circle_usdc_xrpl: "Circle USDC on XRPL",
    compound_v3: "Compound III",
    compute_budget: "Compute Budget",
    conditional_tokens: "Conditional Tokens",
    convert_to_assets_publisher: "ConvertToAssetsPublisher",
    coredao: "Core DAO",
    cosmos_authz: "Cosmos authz",
    cosmos_bank: "Cosmos bank",
    cosmos_distribution: "Cosmos staking rewards",
    cosmos_feegrant: "Cosmos fee grants",
    cosmos_gov: "Cosmos governance",
    cosmos_staking: "Cosmos staking",
    cosmwasm: "CosmWasm",
    counterparty: "Counterparty",
    cow_amm: "CoW AMM",
    cowswap: "CoW Swap",
    credit_coop_bridge: "Credit Coop Bridge",
    crema: "Crema",
    cropper: "Cropper",
    cryptopunks: "CryptoPunks",
    curve: "Curve pools",
    curve_steth: "Curve ETH/stETH",
    custom_staking_ccip_receiver: "CCIP custom staking receiver",
    da_builder: "DA Builder",
    daimo_relayer: "Daimo relayer",
    debot_router: "Debot Router",
    debridge_dln: "deBridge DLN",
    defisaver: "DeFi Saver",
    defituna: "DefiTuna",
    denali: "Denali",
    deriverse: "Deriverse",
    dexlab: "DexLab",
    dflow_aggregator_v4: "DFlow",
    drift_ccip_receiver: "Drift TransferDetail",
    dydx: "dYdX",
    dydx_clob: "dYdX order book",
    dydx_sending: "dYdX subaccounts",
    ed25519_program: "Ed25519 Signature Verify",
    eigenlayer: "EigenLayer",
    eip7702: "EIP-7702 delegation",
    ekubo: "Ekubo",
    ens: "ENS",
    enso: "Enso",
    enzyme: "Enzyme",
    erc1155: "ERC1155",
    erc20: "ERC20",
    erc4337: "ERC-4337",
    erc4626: "ERC4626",
    erc721: "ERC721",
    ethena: "Ethena",
    ether_ccip_receiver: "Ether CCIP receiver",
    ethereum_consensus: "Ethereum validator deposits",
    etherfi: "ether.fi",
    euler: "Euler EVC",
    exsat: "exSat",
    farcaster_xmr_btc: "Farcaster XMR\u2194BTC swap",
    fixedfloat: "FixedFloat",
    flash_router: "FLASH",
    flint: "Flint",
    fluid: "Fluid",
    fluid_dex: "Fluid DEX",
    fluid_dex_observation_upkeep: "Fluid DEX observation automation",
    flux: "Flux",
    fluxbeam: "FluxBeam",
    folks_finance: "Folks Finance",
    folks_finance_ccip_data: "Folks Finance CCIP data adapter",
    frax_ether: "Frax Ether",
    freedomxmr: "FreedomXMR",
    garden: "Garden",
    garden_htlc: "Garden HTLC",
    gatorswap: "GatorSwap",
    gavel: "Gavel",
    geist: "Geist",
    generic: "Generic",
    gnosis_safe: "Gnosis Safe",
    goonfi_v2: "GoonFi v2",
    goosefx_gamma: "GooseFX Gamma",
    guacswap: "Guacswap",
    gyd_escrow_ccip_receiver: "GYD L1 CCIP escrow",
    hadron: "Hadron",
    hathor: "Hathor",
    heaven: "Heaven",
    helium_treasury: "Helium Treasury Management",
    highway_bridge: "Highway Bridge",
    hop: "Hop",
    huma: "Huma",
    humidifi: "HumidiFi",
    hylo_exchange: "Hylo Exchange",
    hylo_stability_pool: "Hylo Stability Pool",
    hyperlane: "Hyperlane",
    hyperliquid_account: "Hyperliquid account",
    hyperliquid_bridge: "Hyperliquid bridge",
    hyperliquid_bridge2: "Hyperliquid Bridge2",
    hyperliquid_evm: "HyperEVM via HyperCore",
    hyperliquid_staking: "Hyperliquid staking",
    hyperliquid_trading: "Hyperliquid trading",
    hyperliquid_transfer: "Hyperliquid transfers",
    hyperliquid_validator: "Hyperliquid validators and deployers",
    hyperliquid_vault: "Hyperliquid vaults",
    ibc_core: "IBC relayer",
    ibc_transfer: "IBC transfer",
    icecreamswap_aggregator: "IceCreamSwap Aggregator",
    invariant: "Invariant",
    iziswap: "iZiSwap",
    iziswap_pool: "iZiSwap",
    jaredfromsubway: "jaredfromsubway",
    joinmarket_coinjoin: "JoinMarket CoinJoin",
    jupiter_dca: "Jupiter DCA",
    jupiter_lend_earn: "Jupiter Lend Earn",
    jupiter_limit_order: "Jupiter Limit Order",
    jupiter_limit_order_v2: "Jupiter Limit Order v2",
    jupiter_order_engine: "Jupiter Order Engine",
    jupiter_perps: "Jupiter Perps",
    jupiter_rfq_v2: "Jupiter RFQ",
    jupiter_v4: "Jupiter v4",
    jupiter_v6: "Jupiter",
    juplend_amm: "JupLend AMM",
    juplend_liquidity: "JupLend Liquidity",
    justlend: "JustLend",
    juststable: "JustStable",
    kipseli: "Kipseli",
    klaster_ccip_gateway: "Klaster CCIP gateway",
    kmon_minter_ccip_receiver: "Kmon minter",
    krystal_v3_utils: "Krystal V3Utils",
    krystal_v4_utils: "Krystal V4Utils",
    kuru: "Kuru",
    kyber_legacy: "Kyber Network",
    kyberswap_fairflow: "KyberSwap FairFlow",
    kyberswap_limit_order: "KyberSwap Limit Order",
    kyberswap_meta_aggregator: "KyberSwap",
    kyberswap_zap: "KyberSwap Zap",
    laposte: "LaPoste",
    layerzero_dvn: "LayerZero DVN",
    layerzero_endpoint: "LayerZero ENDPOINT",
    layerzero_executor: "LayerZero EXECUTOR",
    layerzero_oft: "LayerZero OFT",
    layerzero_onft: "LayerZero ONFT",
    layerzero_pricefeed: "LayerZero PRICEFEED",
    layerzero_read: "LayerZero Read",
    layerzero_uln: "LayerZero ULN",
    layerzero_v1: "LayerZero V1",
    layerzero_v2: "LayerZero V2",
    lemmingsfi: "LemmingsFi",
    lendvest_lido_upkeep: "Lendvest Lido upkeep",
    lido: "Lido",
    lifi: "LI.FI",
    lifi_receivers: "LI.FI Receiver",
    lifi_solana_program_1: "LI.FI Tracker",
    lifinity_v2: "Lifinity v2",
    lighthouse: "Lighthouse",
    limit_order_registry_upkeep: "Limit order registry upkeep",
    limitbreak_payment_processor: "Payment Processor (Limit Break)",
    linea_bridge: "Linea Bridge",
    linear_ccip_receiver: "Linear withdrawal",
    liquidswap: "Liquidswap",
    loader_v4: "Loader v4",
    lombard: "Lombard",
    lunarbase: "LunarBase",
    m_swap: "M Swap",
    magic_eden_v2: "Magic Eden v2",
    maker_dss: "Maker DSS",
    maker_dss_cron_keeper_upkeep: "MakerDAO DssCron keeper",
    manifest: "Manifest",
    maple: "Maple",
    marinade: "Marinade Finance",
    maverick_v2: "Maverick V2",
    mayachain: "Maya Protocol",
    mayan: "Mayan",
    mayan_cpi_proxy: "Mayan CPI Proxy",
    mayan_fast_mctp: "Mayan Fast MCTP",
    mayan_fee_manager: "Mayan Fee Manager",
    mayan_mctp: "Mayan MCTP",
    mayan_spl_utils: "Mayan SPL Utils",
    mayan_swift_v1: "Mayan Swift v1",
    mayan_swift_v2: "Mayan Swift v2",
    mercurial: "Mercurial",
    metadao: "MetaDAO",
    metamask_bridge: "MetaMask Bridge",
    metamask_delegation: "MetaMask Delegation Framework",
    metamask_swaps: "MetaMask Swaps",
    metaplex_bubblegum: "Metaplex Bubblegum",
    metaplex_core: "Metaplex Core",
    metaplex_token_metadata: "Metaplex Token Metadata",
    meteora_damm_v2: "Meteora DAMM v2",
    meteora_dbc: "Meteora Dynamic Bonding Curve",
    meteora_dlmm: "Meteora DLMM",
    meteora_dynamic_vault: "Meteora Dynamic Vault",
    meteora_pools: "Meteora Pools",
    metric: "Metric",
    metric_oracles: "Metric oracles",
    mev_blocker: "MEV Blocker",
    mev_bot: "MEV Bot",
    monero_ringct: "Monero RingCT",
    moonit: "Moonit",
    morpho_blue: "Morpho Blue",
    morpho_bundler3: "Morpho Bundler3",
    mtoken: "MToken",
    multi_lock_mint_ccip_receiver: "Multi lock/mint ERC-721 pool",
    multicall: "Multicall",
    native_ccip_receiver: "Native bridge transfer",
    native_loader: "Native Loader",
    native_transfer: "Native transfer",
    near_intents: "NEAR Intents",
    neverland: "Neverland",
    nex_labs_ccip_receiver: "NEX cross-chain index action",
    nft_floor_ccip_receiver: "NFT floor price message",
    nft_release_ccip_receiver: "NFT bridge release",
    noble_forwarding: "Noble forwarding",
    noot_ccip_receiver: "Noot bridge transfer",
    obric_v2: "Obric v2",
    obsidian: "Obsidian",
    odos: "Odos V2",
    oft_ccip_receiver: "OFT CCIP token transfer",
    okx_dex_router: "OKX DEX Router",
    okx_xbridge: "OKX XBridge",
    omni_layer: "Omni Layer",
    omnibridge: "OmniBridge",
    omnipair: "Omnipair",
    one_dex: "1DEX",
    oneinch: "1inch",
    oneinch_aqua: "1inch Aqua",
    oneinch_delegation: "1inch Delegation",
    oneinch_executor: "1inch Executor",
    oneinch_fusion: "1inch Fusion",
    oneinch_fusion_dst: "1inch Fusion+ dst",
    oneinch_fusion_dst_v2: "1inch Fusion+ dst v2",
    oneinch_fusion_plus: "1inch Fusion+",
    oneinch_fusion_src: "1inch Fusion+ src",
    oneinch_fusion_src_v2: "1inch Fusion+ src v2",
    oneinch_fusion_whitelist: "1inch Fusion+ whitelist",
    oneinch_fusion_whitelist_v2: "1inch Fusion+ whitelist v2",
    oneinch_solana_fusion: "1inch Fusion (Solana)",
    oneinch_solana_fusion_whitelist: "1inch Fusion Whitelist",
    oneinch_swap_vm: "1inch SwapVM",
    op_fork_bridge: "OP Fork Bridges",
    op_return_data: "OP_RETURN data",
    op_stack_batcher: "OP Stack Batcher",
    op_stack_bridge: "OP Stack Bridge",
    op_stack_l1_block: "OP Stack L1Block",
    openbook_v2: "OpenBook v2",
    orca_v1: "Orca v1",
    orca_v2: "Orca v2",
    orca_whirlpool: "Orca Whirlpool",
    ordinals: "Ordinals",
    origin_protocol: "Origin Protocol",
    osmosis_swap: "Osmosis",
    outland: "Outland",
    packed_steps: "Packed step executor",
    pancakeswap_factory: "PancakeSwap",
    pancakeswap_router: "PancakeSwap",
    pancakeswap_solana: "PancakeSwap",
    pancakeswap_v3_pool: "PancakeSwap",
    pangolin_v3: "Pangolin V3",
    paraswap: "ParaSwap",
    pendle: "Pendle",
    penguin: "Penguin",
    perena: "Perena",
    perena_star_v2: "Perena Star v2",
    phoenix: "Phoenix",
    phoenix_eternal: "Phoenix Eternal",
    plasma_vault: "Plasma Vault",
    pols_v2_migration: "PolsV2MigrationEth",
    polygon_cdk_bridge: "CDK Unified Bridge",
    polygon_pos_bridge: "Polygon PoS Bridge",
    polymarket_ctf_exchange: "Polymarket CTF Exchange",
    polymarket_neg_risk: "Polymarket Neg Risk",
    polymarket_uma_adapter: "Polymarket UMA Adapter",
    pons_v2_curve: "Pons V2 curve",
    pons_v2_factory: "Pons V2",
    privacy_pools: "Privacy Pools / 0xbow",
    private_packed_searchers: "Private command executor",
    private_swap_executors: "Private swap executor",
    program_metadata: "Program Metadata",
    pump_router: "Pump Router",
    pumpfun: "pump.fun",
    pumpfun_fee: "pump.fun fees",
    pumpfun_mayhem: "Pump Mayhem",
    pumpswap_amm: "PumpSwap",
    quantum: "Quantum",
    quay: "Quay",
    railgun: "RAILGUN",
    rare_bridge_ccip_receiver: "Rare Bridge",
    raydium_amm_v4: "Raydium AMM v4",
    raydium_clmm: "Raydium CLMM",
    raydium_cpmm: "Raydium CPMM",
    raydium_launchlab: "Raydium LaunchLab",
    re_reserve_feeds: "Re Protocol reserve feeds",
    relay: "Relay",
    ripple_rlusd: "Ripple USD",
    riptide: "Riptide",
    rootstock: "Rootstock",
    runes: "Runes",
    runespear: "Runespear / SuperEarn",
    runner_rodeo: "RunnerRodeo",
    saber: "Saber",
    saber_decimals: "Saber (Decimals)",
    safe_rollup: "Safe Rollup (Sepolia demonstration)",
    sanctum_infinity: "Sanctum Infinity",
    sanctum_multi_validator: "Sanctum Multi-Validator Pool",
    sanctum_prop_s: "Sanctum Prop S",
    sanctum_router: "Sanctum Router",
    sanctum_single_validator: "Sanctum Single-Validator Pool",
    sanctum_sols: "Sanctum SOLS",
    sanctum_spl_stake_pool: "Sanctum SPL Stake Pool",
    saros: "Saros",
    saros_dlmm: "Saros DLMM",
    save_cre_receiver: "SAVE CRE Receiver",
    scale_amm: "Scale AMM",
    scale_vmm: "Scale VMM",
    scorch: "Scorch",
    scorch_2: "Scorch",
    scroll_bridge: "Scroll Bridge",
    seaport: "Seaport",
    secp256k1_program: "Secp256k1 Signature Verify",
    sideshift: "SideShift.ai",
    sky_usds: "Sky / USDS",
    socket: "Socket",
    solayer: "Solayer",
    solfi: "SolFi",
    solfi_v2: "SolFi v2",
    soucore_ccip_receiver: "SOUCore CCIP receiver",
    spl_memo_v1: "Memo v1",
    spl_memo_v2: "Memo",
    spl_token: "SPL Token",
    spl_token_2022: "Token-2022",
    spl_token_swap: "SPL Token Swap",
    stabble_clmm: "Stabble CLMM",
    stabble_stable_swap: "Stabble Stable Swap",
    stabble_weighted_swap: "Stabble Weighted Swap",
    stableswap: "Stableswap",
    stacks: "Stacks",
    stake: "Stake Program",
    stakedao_votemarket: "Stake DAO Votemarket",
    stargate: "Stargate Finance",
    starkgate: "StarkGate",
    starknet_messaging: "Starknet Messaging",
    stepn: "StepN",
    strap_guard: "STRAP transaction guard",
    sunpump: "SunPump",
    sunswap: "SunSwap",
    sushiswap_router: "SushiSwap",
    sushiswap_v2_factory: "SushiSwap",
    swapx: "SwapX router",
    symbiosis: "Symbiosis",
    syncswap_v1: "SyncSwap V1",
    syncswap_v2_1_aqua: "SyncSwap V2.1 Aqua",
    synthereum_ccip_bridge: "Synthereum CCIP bridge",
    syscoin: "Syscoin",
    system: "System Program",
    taiko_bridge: "Taiko Bridge",
    taurusfi: "TaurusFi",
    teleport: "Teleport / Abridge",
    teleswap: "TeleSwap",
    tenbin: "Tenbin",
    tensor_swap: "Tensor Swap",
    tessera_v: "TesseraV",
    tether: "Tether USDT (issuer)",
    thorchain: "THORChain",
    thorchain_deposit: "THORChain",
    thorchain_memo: "THORChain-style memo",
    thorchain_node: "THORChain node operations",
    tibbir: "Tibbir Bridge",
    tokemak_incentive_prices_upkeep: "Tokemak incentive prices upkeep",
    tokemak_messaging: "Tokemak Cross-Chain Messaging",
    tokemak_stats_upkeep: "Tokemak stats upkeep",
    tornado_cash: "Tornado Cash",
    tornado_cash_nova: "Tornado Cash Nova",
    trench: "Trench",
    trends: "Trends",
    truf_ccip_receiver: "TRUF transfer",
    tycho: "Tycho",
    uma_optimistic_oracle: "UMA Optimistic Oracle",
    unattributed_coinjoin: "Unattributed CoinJoin",
    uniswap_calibur: "Uniswap Calibur",
    uniswap_liquidity_launchpad: "Uniswap Liquidity Launchpad",
    uniswap_permissioned_pools: "Uniswap Permissioned Pools",
    uniswap_permit2: "Permit2",
    uniswap_protocol_fees: "Uniswap Protocol Fees",
    uniswap_stable_pair: "Uniswap StablePair Hook",
    uniswap_swap_proxy: "Uniswap SwapProxy",
    uniswap_the_compact: "Uniswap The Compact",
    uniswap_universal_router: "Uniswap Universal Router",
    uniswap_v1_exchange: "Uniswap V1",
    uniswap_v1_factory: "Uniswap V1",
    uniswap_v2_factory: "Uniswap V2",
    uniswap_v2_migrator: "Uniswap V2 Migrator",
    uniswap_v2_pair: "Uniswap V2",
    uniswap_v2_router: "Uniswap V2",
    uniswap_v3_factory: "Uniswap V3",
    uniswap_v3_migrator: "Uniswap V3 Migrator",
    uniswap_v3_pool: "Uniswap V3",
    uniswap_v3_position_manager: "Uniswap V3 Positions",
    uniswap_v3_router: "Uniswap V3",
    uniswap_v3_staker: "Uniswap V3 Staker",
    uniswap_v3_utilities: "Uniswap V3 utilities",
    uniswap_v4: "Uniswap V4",
    uniswap_v4_position_manager: "Uniswap V4 Positions",
    uniswap_v4_utilities: "Uniswap V4 utilities",
    uniswapx: "UniswapX",
    uniswapx_utilities: "UniswapX utilities",
    usdt0: "USDT0 / Legacy Mesh",
    vault_liquid_unstake: "VaultLiquidUnstake",
    veda_boring_vault: "Veda BoringVault",
    virtuals: "Virtuals",
    voltr: "Voltr",
    vote: "Vote Program",
    wagyu: "Wagyu bridge",
    wasabi_coinjoin: "Wasabi CoinJoin",
    whalestreet: "WhaleStreet",
    whirlpool_coinjoin: "Whirlpool CoinJoin",
    winnables_ccip_receiver: "Winnables Ccip Receiver",
    wintermute: "Wintermute Market Maker",
    wishing_pond: "Wishing Pond",
    woofi: "WOOFi",
    wormhole: "Wormhole",
    wormhole_cctp_with_executor: "Wormhole CCTP With Executor",
    wormhole_core_bridge: "Wormhole Core Bridge",
    wormhole_executor: "Wormhole Executor",
    wormhole_post_message_shim: "Wormhole Post Message Shim",
    wormhole_token_bridge: "Wormhole Token Bridge",
    wormhole_verify_vaa_shim: "Wormhole Verify VAA Shim",
    x2y2: "X2Y2",
    xerc20_ccip_receiver: "CCIP xERC20 transfer",
    xmr_btc_swap: "XMR\u2194BTC atomic swap",
    xorca: "xORCA",
    xswap: "XSwap",
    zcash_shielded: "Zcash shielded pools",
    zeroex: "0x",
    zerofi: "ZeroFi",
    zkbob: "zkBob",
    zksync_bridge: "ZK Stack Bridge",
    zodiac: "Zodiac"
  }
};

// src/metadata-analytics/protocolNames.ts
var PROTOCOL_CATALOG_CATEGORIES = [
  "bridge",
  "exchange",
  "aggregator",
  "lending",
  "flashloan",
  "derivatives",
  "safe",
  "account_abstraction",
  "governance",
  "oracle",
  "infrastructure",
  "erc20",
  "nft",
  "staking",
  "mev",
  "exploit",
  "privacy",
  "gambling",
  "instant_swap",
  "other"
];
var SnapshotSchema = z.object({
  names: z.record(z.string(), z.string()).default({}),
  categories: z.record(z.string(), z.string()).default({}),
  category_labels: z.record(z.string(), z.string()).default({}),
  brand_entity_types: z.record(z.string(), z.string()).default({})
});
var SNAPSHOT = SnapshotSchema.parse(protocol_names_generated_default);
var NAMES = Object.freeze(SNAPSHOT.names);
var CATEGORIES = Object.freeze(SNAPSHOT.categories);
var CATEGORY_LABELS = Object.freeze(SNAPSHOT.category_labels);
var BRAND_ENTITY_TYPES = Object.freeze(SNAPSHOT.brand_entity_types);
var KNOWN_CATEGORIES = new Set(PROTOCOL_CATALOG_CATEGORIES);
function protocolCategoryLabel(category) {
  if (!category) return void 0;
  const label = Object.prototype.hasOwnProperty.call(CATEGORY_LABELS, category) ? CATEGORY_LABELS[category] : void 0;
  return label?.trim() || category.replace(/_/g, " ");
}
function catalogProtocolIds() {
  return Object.keys(NAMES);
}
function protocolDisplayName(protocolId) {
  if (!protocolId) return void 0;
  const name = Object.prototype.hasOwnProperty.call(NAMES, protocolId) ? NAMES[protocolId] : void 0;
  return typeof name === "string" && name.trim() ? name : void 0;
}
var alnum = (text) => text.toLowerCase().replace(/[^a-z0-9]/g, "");
var families = globalSingleton("metadata-analytics/protocolFamilyNames", () => ({
  names: /* @__PURE__ */ new Map()
}));
function protocolFamilyName(namespace) {
  const key = (namespace ?? "").trim().toLowerCase();
  if (!key) return void 0;
  if (families.names.has(key)) return families.names.get(key);
  const want = alnum(key);
  let found;
  for (const [id, name] of Object.entries(NAMES)) {
    if (id !== key && !id.startsWith(`${key}_`)) continue;
    const words = name.trim().split(/\s+/);
    for (let count = 1; count <= words.length; count += 1) {
      const spelled = alnum(words.slice(0, count).join(""));
      if (spelled === want) found = words.slice(0, count).join(" ");
      if (spelled.length >= want.length) break;
    }
    if (found) break;
  }
  families.names.set(key, found);
  return found;
}
function protocolCategory(protocolId) {
  if (!protocolId) return void 0;
  const category = Object.prototype.hasOwnProperty.call(CATEGORIES, protocolId) ? CATEGORIES[protocolId] : void 0;
  return category && KNOWN_CATEGORIES.has(category) ? category : void 0;
}
function catalogCategories() {
  return CATEGORIES;
}
function brandEntityType(name) {
  const key = (name ?? "").trim();
  if (!key) return void 0;
  return Object.prototype.hasOwnProperty.call(BRAND_ENTITY_TYPES, key) ? BRAND_ENTITY_TYPES[key] : void 0;
}

export { PROTOCOL_CATALOG_CATEGORIES, brandEntityType, catalogCategories, catalogProtocolIds, protocolCategory, protocolCategoryLabel, protocolDisplayName, protocolFamilyName };
//# sourceMappingURL=chunk-IHYVRZAP.js.map
//# sourceMappingURL=chunk-IHYVRZAP.js.map